module.exports = __webpack_public_path__ + "img/UC3400.9dd3817a.png";